namespace Ir.Components.Email.ScheduledEmailFilter {
    interface IViewModel {
        dateRangeOptions: DevExpress.ui.dxDateRangeBox.Properties;
        dateRangeComponent: DevExpress.ui.dxDateRangeBox;

        startTimeOptions: DevExpress.ui.dxDateBox.Properties;
        startTimeComponent: DevExpress.ui.dxDateBox;

        endTimeOptions: DevExpress.ui.dxDateBox.Properties;
        endTimeComponent: DevExpress.ui.dxDateBox;

        applyOptions: DevExpress.ui.dxButton.Properties;
    }
    interface IParams {
        result: ScheduledEmailResultVM,
        callback: (filtervalue: any) => void;
    }

    let popupComponent: DevExpress.ui.dxPopup;
    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        this.dateRangeOptions = {
            multiView: false,
            displayFormat: params.result.dateFormat,
            value: [params.result.startDate, params.result.endDate],
            labelMode: "hidden",
            showClearButton: true,
            useMaskBehavior: true,
            onInitialized(e) {
                self.dateRangeComponent = e.component;
            },
        };
        this.startTimeOptions = {
            value: params.result.startTime,
            type: 'time',
            useMaskBehavior: true,
            showDropDownButton: false,
            displayFormat: irSettings.displayTimeFormat,
            showClearButton: true,
            onInitialized(e) {
                self.startTimeComponent = e.component;
            },
            onValueChanged(e) {
                let endTime = self.endTimeComponent.option("value");
                if (e.value > endTime) {
                    self.endTimeComponent.option("value", e.value);
                }
            }
        };
        this.endTimeOptions = {
            value: params.result.endTime,
            type: 'time',
            useMaskBehavior: true,
            showDropDownButton: false,
            displayFormat: irSettings.displayTimeFormat,
            showClearButton: true,
            onInitialized(e) {
                self.endTimeComponent = e.component;
            },
            onValueChanged(e) {
                let startTime = self.startTimeComponent.option("value");
                if (e.value < startTime) {
                    self.startTimeComponent.option("value", e.value);
                }
            }
        };
        this.applyOptions = {
            text: 'Apply',
            icon: 'filter',
            onClick() {
                let vals = self.dateRangeComponent.option("value");
                var filterOptions = {
                    startDate: vals && vals.length > 0 ? vals[0] : undefined,
                    endDate: vals && vals.length > 1 ? vals[1] : vals && vals.length > 0 ? vals[0] : undefined,
                    startTime: self.startTimeComponent.option("value"),
                    endTime: self.endTimeComponent.option("value")
                };

                if (filterOptions.startDate && !filterOptions.endDate || !filterOptions.startDate && filterOptions.endDate ||
                    filterOptions.startTime && !filterOptions.endTime || !filterOptions.startTime && filterOptions.endTime) {

                    DevExpress.ui.dialog.alert(`The date range and/or the time range needs to be selected, it is not allowed to select only half of the date or a time`, "Emails Management");
                    return;
                }

                let filtervalue = null;
                if (filterOptions.startDate && filterOptions.endDate) {
                    let daysOfweek = [];
                    let daysOfMonth = []
                    let weeklyFilter = [];
                    let monthlyFilter = [];
                    for (var d = new Date(filterOptions.startDate); d <= filterOptions.endDate; d.setDate(d.getDate() + 1)) {
                        let date = new Date(d);
                        if (daysOfweek.indexOf(date.getDay() + 1) === -1) {
                            daysOfweek.push(date.getDay() + 1);
                        }

                        if (daysOfMonth.indexOf(date.getDate()) === -1) {
                            daysOfMonth.push(date.getDate());
                        }
                    }

                    for (var i = 0; i < daysOfweek.length; i++) {
                        if (weeklyFilter.length > 0) {
                            weeklyFilter.push("or");
                        }

                        weeklyFilter.push(['scheduledDaysFilter', 'contains', `#${daysOfweek[i]}#`]);
                    }

                    for (var i = 0; i < daysOfMonth.length; i++) {
                        if (monthlyFilter.length > 0) {
                            monthlyFilter.push("or");
                        }

                        monthlyFilter.push(['scheduledDaysFilter', 'contains', `#${daysOfMonth[i]}#`]);
                    }

                    filtervalue = [
                        ['schedule', '=', 'Daily'],
                        'or',
                        [
                            ['schedule', '=', 'Weekly'],
                            'and',
                            [weeklyFilter]
                        ],
                        'or',
                        [
                            ['schedule', '=', 'Monthly'],
                            'and',
                            [monthlyFilter]
                        ]
                    ];
                }

                if (filterOptions.startTime && filterOptions.endTime) {
                    if (!filtervalue) {
                        filtervalue = [];
                    }

                    if (filtervalue.length > 0) {
                        filtervalue = [filtervalue, "and"];
                    }

                    const starTimeStr = moment(filterOptions.startTime).format("HH:mm:ss");
                    const endTimeStr = moment(filterOptions.endTime).format("HH:mm:ss");
                    filtervalue.push([["scheduledHour", ">=", starTimeStr], "and", ["scheduledHour", "<=", endTimeStr]]);
                }


                params.callback(filtervalue)

                popupComponent.hide();
            },
        };
    }    
    export function show(result: ScheduledEmailResultVM, callback: (filterValue: any) => void) {
        if (popupComponent) {
            popupComponent.show();
            return;
        }

        let popupOptions = {
            width: 600,
            height: 150,
            showTitle: true,
            title: "Filters",
            visible: false,
            dragEnabled: false,
            hideOnOutsideClick: false,
            showCloseButton: true,
            position: {
                at: "center",
                my: "center",
            },
            onInitialized(e) {
                popupComponent = e.component;
                popupComponent.show();
            }
        } as DevExpress.ui.dxPopover.Properties;

        let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <scheduled-email-filter params="result: result, callback: callback"></scheduled-email-filter>
            </div>`);
        $popover.appendTo('body');

        ko.applyBindings({ popupOptions, result, callback }, $popover[0]);
    }
}